import React from "react";
import { Alert, Card, Table } from "antd";

import { buildAntdColumns, tableToCsvHeaders, tableToCsvRows } from "./dashboardProtoFormat";
import ExportCSV from "../../Components/ExportCSV";

function rowClassName(record) {
  if (record.row_type === "grand_total") return "dash-row-grand";
  if (record.row_type === "plan_total") return "dash-row-total";
  if (record.row_type === "plan_header") return "dash-row-header";
  return "";
}

export default function DashboardProtoTable({ table, loading, filename }) {
  if (!table) return null;

  const columns = buildAntdColumns(table.columns || []);
  const dataSource = (table.rows || []).map((row, idx) => ({ key: String(idx), ...row }));

  return (
    <Card title={table.title || "Tabela"} size="small" style={{ marginBottom: 16 }}>
      {table.error ? <Alert type="warning" message={table.error} style={{ marginBottom: 12 }} /> : null}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
        <ExportCSV
          name="Download CSV"
          className="ant-btn ant-btn-default"
          filename={filename || "tabela.csv"}
          data={tableToCsvRows(table)}
          headers={tableToCsvHeaders(table)}
        />
      </div>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        pagination={false}
        size="small"
        scroll={{ x: true }}
        rowClassName={rowClassName}
      />
    </Card>
  );
}
